var idResize; //for resize-timer
var windowsWidth = jQuery(window).outerWidth();
let movement = "";
let oldx = 0;
let oldy = -1;
var scroll_start = 0;
var startchange = jQuery(".entry-content")[0];
var startchangeOffsetTop = typeof (startchange) != 'undefined' ? startchange.offsetTop + 0 : 0;
let navbarToggler = jQuery(".navbar-toggler")[0];
/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
function handleHasHiddenTextToggleClassClicked(caller = null)
{
  let actionContainers = jQuery(".action-click-container .action-container .action-one");
  let actionContainersLength = actionContainers.length;
  let i = 1;
  let changedClass = false;
  if (!actionContainersLength)
  {
    actionContainersLength = 0;
  }
  if (actionContainersLength > 0)
  {
    Object.keys(actionContainers).forEach(actionContainer =>
    {
      if (i > Number(actionContainersLength))
      {
        return;
      }
      // let hiddenTextContainer = jQuery(actionContainers[actionContainer]).closest('.has-hidden-text');
      if (jQuery(actionContainers[actionContainer]).hasClass('show'))
      {
        jQuery(actionContainers[actionContainer]).removeClass('show');
        if (caller == actionContainers[actionContainer])
        {
          changedClass = true;
        }
      }
      i++;
    });
  }
  return changedClass;
}
function zw_toggle_mega_menu(menuitem, closestA) {
  closestA = menuitem.closest(".menu-item-has-children")[0].firstChild;
  let closestAInnerText = closestA.innerHTML;
  let closestAHref = jQuery(closestA).attr("href");
  // console.log(closestAHref)
  let parentUL = jQuery(menuitem).parent().parent();
  let nextLvlUl = jQuery(menuitem).siblings(".dropdown-menu");
  // nextLvlUl[0].children[0].innerHTML = closestAInnerText;
  // console.log("nextLvlUl[0].children[0].innerHTML", nextLvlUl[0].children[0].innerHTML)
  nextLvlUl[0].children[0].innerHTML =
    '<span class="back-icon" onclick="zw_toggle_mega_menu_back(jQuery(this))"></span><span class="back-button" ><a href="' +
    closestAHref +
    '">' +
    closestAInnerText +
    "</a></span>";
  jQuery(nextLvlUl).toggleClass("d-flex");
  jQuery(parentUL).toggleClass("invisible");
  jQuery(nextLvlUl).toggleClass("visible");

  if (jQuery(menuitem).parent().parent().hasClass("dropdown-menu")) {
    jQuery(menuitem)
      .parent()
      .parent()
      .children(".backtext")
      .toggleClass("d-none");
  }
}

window.zw_toggle_mega_menu = zw_toggle_mega_menu;

function zw_toggle_mega_menu_back(menuitem) {
  menuitem = jQuery(menuitem).closest(".backtext");
  var parentUL = jQuery(menuitem).parent();
  // zw_main_menu_same_height(parentUL);
  jQuery(menuitem)
    .parents("ul")
    .find(".backtext")
    .each(function () {
      if (jQuery(this).hasClass("d-none")) {
        jQuery(this).removeClass("d-none");
      }
    });
  jQuery(parentUL).toggleClass("d-flex");
  // var parentULwithNullHeight = parentUL.parent().parent('ul.null-height');
  // jQuery(parentULwithNullHeight).toggleClass('null-height');
  var parentULwithNullHeight = parentUL.parent().parent("ul.invisible");
  jQuery(parentULwithNullHeight).toggleClass("invisible");
  jQuery(parentUL).toggleClass("visible");
}

window.zw_toggle_mega_menu_back = zw_toggle_mega_menu_back;

/**
 * Make Main Menu drop-down ul same height
 */

function zw_main_menu_same_height(startElemente) {
  var outerHeight = jQuery("#main-menu").outerHeight();
  var curHeight = jQuery(startElemente).outerHeight();

  if (curHeight > outerHeight) {
    jQuery("#main-menu").css("height", curHeight + "px");
    outerHeight = curHeight;
  }
  var padding = outerHeight - curHeight;
  var calcString =
    "calc(" +
    jQuery(startElemente).css("padding-bottom") +
    " + " +
    padding +
    "px)";

  jQuery(startElemente).css("padding-bottom", calcString);
  jQuery(startElemente).css({
    height: outerHeight + "px",
    width: "100%",
  });
}

window.zw_main_menu_same_height = zw_main_menu_same_height;

/* Scroll to anchor */
function pgshow(e)
{
    var elId = window.location.hash;
    if (elId.length > 1)
    {
        let el = document.getElementById(elId.substr(1));
        if (el) el.scrollIntoView(true);
    }
}
window.pgshow = pgshow;

// pageshow fires after load and on Back/Forward
window.addEventListener("pageshow", pgshow);

function stickyAnimation() {
  // setTimeout(() => { r.style.setProperty('--zw-opacity-sticky-btn', '1') }, 2000);
  var r = document.querySelector(":root");

  function animation() {
    // 10 sec then play animation // nach 2 play naimaton // 4 sec return no animation
    setTimeout(() => {
      r.style.setProperty("--zw-opacity-sticky-btn", "0");

      setTimeout(() => {
        r.style.setProperty("--zw-opacity-sticky-btn", "1");
        setTimeout(() => {
          animation();
        }, 2000);
      }, 2000);
    }, 4000);
  }
  animation();
}

// window.stickyAnimation = stickyAnimation;

/* Share popup function */

function zw_social_share(data) {
  window.open(
    data,
    "Share",
    "height=500,width=760,top=" +
      (jQuery(window).height() / 2 - 250) +
      ", left=" +
      (jQuery(window).width() / 2 - 380) +
      "resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0"
  );
}
window.zw_social_share = zw_social_share;

function zw_show_rating_stars(trigger) {
  jQuery(trigger)
    .next(".rmp-rating-widget__icons-list")
    .removeClass("d-none")
    .addClass("d-flex");
  jQuery(trigger).addClass("d-none");
}
window.zw_show_rating_stars = zw_show_rating_stars;

function zw_hide_rating_after_rate(trigger) {
  jQuery(trigger.currentTarget)
    .closest(".js-rmp-rating-widget")
    .delay(2000)
    .queue(function () {
      jQuery(this).addClass("d-none").dequeue();
    });
}
window.zw_hide_rating_after_rate = zw_hide_rating_after_rate;

function updateDropdownHeights()
{
  const ddowns = document.querySelectorAll(
    '.main-header .main-menu-container #main-menu .menu-item-has-children .dropdown-menu'
  );
  let maxHeight = 0;

  // 1. measure all
  ddowns.forEach(el =>
  {
    // reset height first to get natural height
    el.style.height = 'auto';

    const h = el.scrollHeight;
    if (h > maxHeight)
    {
      maxHeight = h;
    }
  });
  console.group()
  ddowns.forEach(el =>
  {
    console.debug(el.classList)
    console.debug(el.classList.contains("level-0"))
    if (!el.classList.contains("level-0")) return;
    el.style.height = maxHeight + 2 + 'px';
    el.style.rowGap = 0 + 'px';
    console.debug('maxHeight:', maxHeight);
  });
  console.groupEnd();
}

jQuery(document).ready(function () {
  const menu = document.querySelector(
    '.main-header .main-menu-container #main-menu'
  );

  if (menu)
  {
    let scheduled = false;

    const scheduleUpdate = () =>
    {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(() =>
      {
        scheduled = false;
        updateDropdownHeights();
      });
    };


    //INFO: observer for dynamically setting height of the first ul element since css was giving us trouble 
    // const observer = new MutationObserver(mutations =>
    // {
    //   for (const mutation of mutations)
    //   {
    //     const el = mutation.target;

    //     if (!el.classList?.contains('menu-item-has-children')) continue;

    //     scheduleUpdate();
    //   }
    // });

    // observer.observe(menu, {
    //   attributes: true,
    //   subtree: true,
    //   attributeFilter: ['class'],
    //   attributeOldValue: true
    // });
  }
  window.setTimeout(() => {
    // Initialize essential variables outside of the scroll handlers to avoid repeated calculations.
    const windowsWidth = jQuery(window).width();
    const mainHeader = jQuery(".main-header");
    let scrollStart = 0;
    let startChangeOffsetTop = Math.max(
      0,
      parseInt(mainHeader.data("offset-top"), 10) || 0
    );

    // Function to toggle sticky class based on scroll position.
    function toggleStickyHeader() {
      let scrollStart = jQuery(window).scrollTop();
      if (scrollStart > startChangeOffsetTop) {
        mainHeader.addClass("sticky");
      } else {
        if (
          windowsWidth < 1250 &&
          !jQuery("#mainmenutoggler").hasClass("show")
        ) {
          mainHeader.removeClass("sticky");
        } else if (windowsWidth >= 1250) {
          mainHeader.removeClass("sticky");
        }
      }
    }
    window.toggleStickyHeader = toggleStickyHeader;

    // Call the function once initially and bind it to scroll events.
    toggleStickyHeader();
    jQuery(window).scroll(toggleStickyHeader);

    // Sticky header and action handling for different window widths.
    // stickyAnimation();
    // Handling social share toggler clicks.
    // jQuery('body').on('click', '.zw-social-share .zw-social-share-toggler', function (e)
    // {
    //     e.preventDefault();
    //     let $currentTarget = jQuery(e.currentTarget);
    //     let ariaStatus = $currentTarget.attr('aria-expanded') === 'false';
    //     $currentTarget.attr('aria-expanded', ariaStatus ? 'true' : 'false');
    //     $currentTarget.parents('.zw-social-share').find('.zw-share-dropdown-menu').toggleClass('show');
    // });

    // Rating widget click handling.
    jQuery(".js-rmp-rating-widget .js-rmp-rating-icon").click(function (e) {
      zw_hide_rating_after_rate(e);
    });

    // Mutation observer for navbar toggler changes.
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        switch (mutation.type) {
          case "attributes":
            switch (mutation.attributeName) {
              case "aria-expanded":
                scroll_start = jQuery(this).scrollTop();
                if (startchangeOffsetTop < 0) {
                  startchangeOffsetTop = 0;
                }
                if (
                  mutation.target.attributes["aria-expanded"].value == "true"
                ) {
                  jQuery(".main-header").addClass("sticky");
                } else if (scroll_start <= startchangeOffsetTop) {
                  jQuery(".main-header").removeClass("sticky");
                }
                break;
            }
            break;
        }
      });
    });

    // Assuming navbarToggler is defined correctly elsewhere in your script.
    if (typeof (navbarToggler) != 'undefined')
    {
      observer.observe(navbarToggler, {
        attributes: true,
        subtree: true,
        childList: true,
        attributeFilter: ["aria-expanded"],
      });
    }


    // Hide navigation on item click.
    jQuery("#main-menu .dropdown-item, #main-menu .nav-link").on(
      "click",
      function () {
        jQuery(".navbar-collapse").collapse("hide");
      }
    );
  }, 0);

  //sticky iconc click handler 
  jQuery(".action-click-container .action-container .action-one").click(function (e)
  {
    const changedClass = handleHasHiddenTextToggleClassClicked(this);
    if (!changedClass)
    {
      jQuery(this).toggleClass('show');
    }
  });
});

/**
 * On Resize
 */
jQuery(window).resize(function () {
  // updateDropdownHeights();
  let windowsWidth = jQuery(window).outerWidth();
  if (windowsWidth >= 1250) {
    /**
     * REMOVE ALL CLASSES FROM OPEN MEGA MENU MOBILE to enable desktop hover menu on resize
     */
    // if (jQuery("#main-menu").hasClass("invisible")) {
    //   jQuery("#main-menu").removeClass("invisible");
    // }

    // if (jQuery("#mainmenutoggler").hasClass("show")) {
    //   jQuery("#mainmenutoggler").removeClass("show");
    // }

    // if (jQuery(".main-header").hasClass("sticky")) {
    //   jQuery(".sticky").removeClass("sticky");
    // }
    // jQuery("#main-menu .dropdown-menu.megamenu").each(function () {
    //   if (jQuery(this).hasClass("d-flex")) {
    //     jQuery(this).removeClass("d-flex");
    //   }
    //   if (jQuery(this).hasClass("visible")) {
    //     jQuery(this).removeClass("visible");
    //   }
    //   if (jQuery(this).hasClass("invisible")) {
    //     jQuery(this).removeClass("invisible");
    //   }
    // });
  }

  /* this document */
});

jQuery(document).click(function ()
{
  let container = jQuery(".action-click-container .action-container");
  if (!container.is(event.target) && !container.has(event.target).length)
  {
    handleHasHiddenTextToggleClassClicked();
  }
});

////////////////////////////////////////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", function () {

	const mediaQuery = window.matchMedia("(min-width: 1200px)");
	let isInitialized = false;

	function initMenu() {

		if (isInitialized) return;
		isInitialized = true;

		const level0Items = document.querySelectorAll(".menu-item-has-children.level-0");
		const level1Items = document.querySelectorAll(".menu-item-has-children.level-1");

		// -----------------------------
		// HELPERS
		// -----------------------------
		function closeAllLevel1Submenus() {
			document.querySelectorAll(".menu-item-has-children.level-1").forEach(function (li) {
				li.classList.remove("submenu-is-active");

				const submenu = li.querySelector("ul");
				if (submenu) submenu.classList.remove("submenu-open");

				const btn = li.querySelector(".submenu-toggle");
				if (btn) btn.setAttribute("aria-expanded", "false");
			});
		}

		function closeAllLevel0Dropdowns(exceptItem = null) {
			level0Items.forEach(function (item) {
				if (exceptItem && item === exceptItem) return;

				item.classList.remove("dropdown-is-active");

				const trigger = item.querySelector("button");
				if (trigger) trigger.setAttribute("aria-expanded", "false");
			});
		}

		// -----------------------------
		// LEVEL 1: SUBMENU TOGGLE
		// -----------------------------
		level1Items.forEach(function (li, index) {

			const submenu = li.querySelector("ul");
			if (!submenu) return;

			if (!submenu.id) {
				submenu.id = "submenu-level1-" + index;
			}

			const link = li.querySelector("a");
			if (!link) return;

			// prevent duplicate buttons
			if (li.querySelector(".submenu-toggle")) return;

			const button = document.createElement("button");
			button.classList.add("submenu-toggle");
			button.setAttribute("aria-expanded", "false");
			button.setAttribute("aria-controls", submenu.id);
			button.setAttribute("aria-label", "Toggle submenu");
			button.type = "button";
			button.innerHTML = '<span class="toggle-icon" aria-hidden="true"></span>';

			button.addEventListener("click", function (e) {
				e.preventDefault();
				e.stopPropagation();

				const expanded = this.getAttribute("aria-expanded") === "true";

				// close other level 1 submenus
				document.querySelectorAll(".menu-item-has-children.level-1").forEach(function (item) {
					if (item !== li) {
						const otherSubmenu = item.querySelector("ul");
						const otherButton = item.querySelector(".submenu-toggle");

						item.classList.remove("submenu-is-active");

						if (otherSubmenu) otherSubmenu.classList.remove("submenu-open");
						if (otherButton) otherButton.setAttribute("aria-expanded", "false");
					}
				});

				if (expanded) {
					this.setAttribute("aria-expanded", "false");
					submenu.classList.remove("submenu-open");
					li.classList.remove("submenu-is-active");
				} else {
					this.setAttribute("aria-expanded", "true");
					submenu.classList.add("submenu-open");
					li.classList.add("submenu-is-active");
				}
			});

			link.insertAdjacentElement("afterend", button);
		});

		// -----------------------------
		// LEVEL 0: MAIN DROPDOWN
		// -----------------------------
		level0Items.forEach(function (menuItem) {

			const trigger = menuItem.querySelector(":scope > button, :scope > a");
			if (!trigger) return;

			trigger.addEventListener("click", function (e) {
				e.preventDefault();

				const isActive = menuItem.classList.contains("dropdown-is-active");

				// 🔥 important fix
				closeAllLevel1Submenus();

				closeAllLevel0Dropdowns(menuItem);

				if (!isActive) {
					menuItem.classList.add("dropdown-is-active");

					if (trigger.tagName === "BUTTON") {
						trigger.setAttribute("aria-expanded", "true");
					}
				} else {
					menuItem.classList.remove("dropdown-is-active");

					if (trigger.tagName === "BUTTON") {
						trigger.setAttribute("aria-expanded", "false");
					}
				}
			});
		});

		// -----------------------------
		// CLICK OUTSIDE
		// -----------------------------
		document.addEventListener("click", function (e) {
			if (!e.target.closest(".menu-item-has-children.level-0")) {
				closeAllLevel1Submenus();
				closeAllLevel0Dropdowns();
			}
		});

		console.log("Desktop menu initialized");
	}

	function destroyMenu() {

		isInitialized = false;

		document.querySelectorAll(".dropdown-is-active").forEach(el => {
			el.classList.remove("dropdown-is-active");
		});

		document.querySelectorAll(".submenu-open").forEach(el => {
			el.classList.remove("submenu-open");
		});

		document.querySelectorAll(".submenu-toggle").forEach(btn => {
			btn.remove();
		});

	}

	function handleBreakpoint(e) {
		if (e.matches) {
			initMenu();     // ≥1200px
		} else {
			destroyMenu();  // <1200px
		}
	}

	// initial run
	handleBreakpoint(mediaQuery);

	// react on resize
	mediaQuery.addEventListener("change", handleBreakpoint);

});